import React from 'react'
import { withTranslation } from 'react-i18next'

export default (scope) => (WrappedComponent) => {
    const withScopedTranslations = (props) => {
      const translateFunction = (key, config) => {
        return props.t(`${scope}.${key}`, config)
      }
        return <WrappedComponent {...props} t={translateFunction} />;
    }

    return withTranslation('translation')(withScopedTranslations);
}
